import React from "react";
import ThemedModal from "../../../components/utilities/ThemedModal";
import { Modal } from "react-bootstrap";
import { Button } from "../../../components";
import { PasswordInput } from "../../../components/forms";
import { ThemedParagraph } from "../../../components/utilities";
import { ModalConfirmationWithReturn } from "../../../types/DefModalOptions";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";

export type UpdatePasswordModalProps = ModalConfirmationWithReturn<string | null, string>;

export const UpdatePasswordModal = ({ 
    backdrop = 'static',
    cancel,
    centered = true,
    defaultValues,
    dialogId,
    dismiss,
    proceed,
    show,
    size = "lg",
    ...rest
}: Readonly<UpdatePasswordModalProps>) => {
    const [password, setPassword] = React.useState('');
    const isPasswordValid = React.useMemo(() => {
        // TODO: more validation
        return password.length >= 6;
    }, [ password ]);

    const onClose = () => cancel!();

    const onSubmit = () => proceed!(password);

    return (
        <Modal backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header>
                <Modal.Title>Create/Update Password?</Modal.Title>
            </ThemedModal.Header>
            <Modal.Body>
                <ThemedParagraph variant="danger" className="mb-3">
                    Warning! It is not recommended to manually set a clients password as this could be insecure. If they have forgotten their password, we recommend they use the "Forgot Password" feature so that they can create their own secure password. If you still want to set this accounts password, then enter the new value below.
                </ThemedParagraph>
                <div>
                    <PasswordInput 
                        label="Password"
                        value={password}
                        onChange={(e: any) => setPassword(_ => e.target.value)}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={onSubmit} disabled={!isPasswordValid}>Update Password</Button>
                <Button variant="light" onClick={onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
};

export function openUpdatePasswordModal(currentPassword: string | null = null) {
    return createConfirmation<UpdatePasswordModalProps, string>(confirmable(UpdatePasswordModal))({
        dialogId: 'update_client_dashboard_modal',
        defaultValues: currentPassword
    });
}